import auth0 from 'auth0-js'
import { Auth0ClientIdToDomainMap } from '../common/Auth0Mapping'

export const auth = new auth0.WebAuth({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientID: Auth0ClientIdToDomainMap.find(x => x.domain === window.location.origin)!.clientid ?? process.env.REACT_APP_AUTH0_CLIENTID,
    scope: 'openid email profile'
})